import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Icon } from '../ui';
import { useArea } from '../../contexts/AreaContext';
import { AREA_THEME } from '../../config/areaConfig';
import { useVerlaufMerken, useScrollstandMerken } from '../ZurueckLink';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { area, isAreaSelected } = useArea();
  // Für „Zurück zu …“ und den Scrollstand beim Zurückgehen.
  useVerlaufMerken();
  useScrollstandMerken();

  // No area chosen yet this session → force the selection screen.
  if (!isAreaSelected) {
    return <Navigate to="/select-system" replace />;
  }

  const theme = AREA_THEME[area];

  return (
    <div
      className="layout"
      data-area={area}
      style={{
        ['--area-accent' as any]: theme.accent,
        ['--area-accent-dark' as any]: theme.accentDark,
        ['--area-soft' as any]: theme.soft,
      }}
    >
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Unter 1024 px liegt die Seitenleiste eingeklappt; dies ist der Weg zu ihr. */}
        <header className="mobile-bar">
          <button
            type="button"
            className="mobile-bar__menu"
            onClick={() => setSidebarOpen(true)}
            aria-label="Menü öffnen"
            aria-expanded={sidebarOpen}
          >
            <Icon.Menu size={22} />
          </button>
          <span className="mobile-bar__title">Seniorenbetreuung Antczak</span>
        </header>
        <main className="main-body">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
